module.exports = "/_assets/images/branding/corval-hex-pattern-tile-dark.svg";